import React from 'react';
import { useRoutes } from 'react-router-dom';
import routes from '../routes';
import { useAuth } from 'src/features/authorization';
import NoAccess from 'src/components/NoAccess/NoAccess';
import { LoadingPage } from 'src/components/LoadingPage/LoadingPage';
import { RouteBreadcrumbsProvider } from 'src/components/RouteBreadcrumbs/RouteBreadcrumbs';
import { ROUTES } from 'src/navigation';

const ExtractFeature = () => {
  const element = useRoutes(routes);
  const { checkAccess } = useAuth();

  const access = checkAccess('SivaAdmin').read;

  if (!access) {
    return <NoAccess />;
  }

  return (
    <RouteBreadcrumbsProvider
      routes={routes}
      basePath={ROUTES.SIVA.ADMIN.EXTRACT.BASE}
      namespace="siva"
      rootKey="dataExtract"
    >
      <React.Suspense fallback={<LoadingPage />}>{element}</React.Suspense>
    </RouteBreadcrumbsProvider>
  );
};

export default ExtractFeature;
